import { inject, Injectable, WritableSignal, signal } from '@angular/core';
import { NavigationService } from '@core';
import { DrillsListTab } from '../../components/drills-list-tabs/drills-list-tabs.component';
import { DrillsListTypeFilter } from '../../components/drills-list-type-filter/drills-list-type-filter.component';

const DEFAULT_TAB: DrillsListTab = 'all';
const DEFAULT_TYPE: DrillsListTypeFilter = 'all';

/**
 * Trzyma stan filtrów listy drilli między nawigacjami. Stan przeżywa wejście
 * w podstronę drilla (detal/edycja/tworzenie) i powrót, a resetuje się do
 * domyślnych, gdy na listę wchodzimy z innego miejsca (np. zmiana zakładki dolnej).
 */
@Injectable({ providedIn: 'root' })
export class DrillsListStateService {
  private readonly navigation: NavigationService = inject(NavigationService);

  readonly searchQuery: WritableSignal<string> = signal<string>('');
  readonly activeTab: WritableSignal<DrillsListTab> = signal<DrillsListTab>(DEFAULT_TAB);
  readonly typeFilter: WritableSignal<DrillsListTypeFilter> = signal<DrillsListTypeFilter>(DEFAULT_TYPE);

  syncOnEnter(): void {
    const previous: string = this.navigation.previousUrl ?? '';
    const cameFromDrillsSubPage: boolean = previous.startsWith('/drills/');
    if (!cameFromDrillsSubPage) {
      this.reset();
    }
  }

  private reset(): void {
    this.searchQuery.set('');
    this.activeTab.set(DEFAULT_TAB);
    this.typeFilter.set(DEFAULT_TYPE);
  }
}
